// import { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   CalendarDays, ListOrdered, Network, ListChecks, SlidersHorizontal,
//   Puzzle, Receipt, PiggyBank, Landmark, Plus,
//   Eye,
//   Pencil,
// } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
// import IsoDateInput from '../../../components/common/Isodateinput';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { savePayrollEntity } from '../../../action/Payroll';
// import AddPayRollPeriodDialog from '../../../components/PayRoll/AddPayrollPeriodDialog';
// import AddPayrollComponentDialog from '../../../components/PayRoll/AddPayrollComponentDialog';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';

// /* Shared bits for this page. Field styling comes from the table theme so the
//    toolbar controls match the table they sit on. */
// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// /* Every table on this page shares these — one place to change the page. */
// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',            // paged, so no scroll box
//   emptyMessage: 'No records found',
//   loadingMessage: 'Loading...',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

// /* Earning / Deduction / Contribution, in the pill language of the table. */
// const TYPE_TONES = { Earning: 'success', Deduction: 'danger', Contribution: 'info' };
// const TypeCell = ({ type }) => <StatusPill label={type} tone={TYPE_TONES[type]} dot={false} />;

// const BoolCell = ({ value }) => (
//   <span className={value ? 'text-primary-700 font-semibold' : 'text-gray-400'}>
//     {value ? 'Yes' : 'No'}
//   </span>
// );

// /* ── Payroll Periods ─────────────────────────────────────────────────────── */
// const PeriodsTab = () => {
//   const dispatch = useDispatch();
//   const { list, loading } = usePayrollEntity('payrollPeriods');
//   const saving = useSelector((s) => s.payroll.entities.payrollPeriods?.saving);

//   const [open, setOpen] = useState(false);
//   const [dialogMode, setDialogMode] = useState('add');
//   const [selectedPeriod, setSelectedPeriod] = useState(null);

//   const [periodType, setPeriodType] = useState('All');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');

//   const { toast, showToast, hideToast } = useToast();

//   const filteredPeriods = list
//     .filter((period) => {
//       // Frequency filter
//       if (periodType !== 'All' && period.frequency !== periodType) {
//         return false;
//       }

//       const periodStart = toIsoDate(period.startDate);
//       const periodEnd = toIsoDate(period.endDate);

//       // From date
//       if (fromDate && periodStart < fromDate) {
//         return false;
//       }

//       // End date filter
//       if (toDate && periodEnd && periodEnd > toDate) {
//         return false;
//       }

//       return true;
//     })

  
//   const handleAddPeriod = () => {
//     setSelectedPeriod(null);
//     setDialogMode('add');
//     setOpen(true);
//   }

//   const handleViewPeriod = (period) => {
//     setSelectedPeriod(period);
//     setDialogMode('view');
//     setOpen(true);
//   }

//   const handleEditPeriod = (period) => {
//     setSelectedPeriod(period);
//     setDialogMode('edit');
//     setOpen(true);
//   }

//   const handleCloseDialog = () => {
//     setOpen(false);
//     setSelectedPeriod(null);
//     setDialogMode('add');
//   }

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Payroll Periods"
//         loading={loading}
//         rows={filteredPeriods}
//         rowKey="id"
//         searchKeys={['code', 'name']}
//         searchPlaceholder="Search periods..."
//         onAdd={{ label: 'New Period', icon: <Plus {...ICON} />, onClick: handleAddPeriod}}
//         toolbarExtra={
//           <div className="flex flex-wrap items-end gap-2">
//             <div>
//               <span className={LABEL}>Period Type</span>
//               <select
//                 value={periodType}
//                 onChange={(e) => setPeriodType(e.target.value)}
//                 className={`${FIELD} w-[130px]`}
//               >
//                 <option value="All">All</option>
//                 <option value="Monthly">Monthly</option>
//                 <option value="Weekly">Weekly</option>
//               </select>
//             </div>
//             <div>
//               <span className={LABEL}>From</span>
//               <IsoDateInput value={fromDate} onChange={setFromDate} className={`${FIELD} w-[150px]`} />
//             </div>
//             <div>
//               <span className={LABEL}>To</span>
//               <IsoDateInput value={toDate} onChange={setToDate} className={`${FIELD} w-[150px]`} />
//             </div>
//           </div>
//         }
//         defaultSort={{ key: 'code', dir: 'asc' }}
//         columns={[
//           { key: 'code', label: 'Period Code', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Period Name', grow: true, className: 'text-gray-700' },
//           {
//             key: 'frequency',
//             label: 'Frequency',
//             align: 'center',
//             className: 'text-gray-600',
//           },
//           { key: 'startDate', label: 'Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.startDate) },
//           { key: 'endDate', label: 'End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
//           { key: 'payDate', label: 'Pay Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.payDate) },
//           statusColumn,
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             render: (r) => (
//               <div className="flex items-center justify-center gap-1">
//                 <button
//                   type="button"
//                   onClick={() => handleViewPeriod(r)}
//                   className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
//                   title="View"
//                   aria-label={`View ${r.name || r.code}`}
//                 >
//                   <Eye size={15} />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => handleEditPeriod(r)}
//                   className="inline-flex h-8 w-8 items-center justify-center rounded-md text-primary-600 hover:bg-gray-100 hover:text-gray-700"
//                   title="Edit"
//                   aria-label={`Edit ${r.name || r.code}`}
//                 >
//                   <Pencil size={15} />
//                 </button>
//               </div>
//             ),
//           },
//         ]}
//       />

//       <AddPayRollPeriodDialog
//         open={open}
//         loading={saving}
//         mode={dialogMode}
//         period={selectedPeriod}
//         existingPeriods={list}
//         onClose={handleCloseDialog}
//         onSave={async (data) => {
//           try {
//             await dispatch(savePayrollEntity('payrollPeriods', data, dialogMode === 'edit'));

//             showToast(
//               dialogMode === 'edit'
//                 ? 'Payroll period updated successfully.'
//                 : 'Payroll period added successfully.',
//               'success'
//             );

//             handleCloseDialog();
//           } catch (error) {
//             showToast(error?.msg || error?.message || 'Failed to save payroll period.', 'error');
//           }
//         }}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </>
//   );
// };

// /* ── Payroll Components ──────────────────────────────────────────────────── */
// const ComponentsTab = () => {
//   const dispatch = useDispatch();
//   const { list, loading } = usePayrollEntity('payrollComponents');
//   const saving = useSelector((s) => s.payroll.entities.payrollComponents?.saving);

//   const [open, setOpen] = useState(false);
//   const [typeFilter, setTypeFilter] = useState('All');

//   const { toast, showToast, hideToast } = useToast();

//   const filteredComponents = [...list]
//   .filter((component) => typeFilter === 'All' || component.type === typeFilter)
//   .sort((a, b) => String(a.code || '').localeCompare(String(b.code || '')));

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Payroll Components"
//         loading={loading}
//         rows={filteredComponents}
//         rowKey="id"
//         searchKeys={['code', 'name']}
//         searchPlaceholder="Search components..."
//         onAdd={{ label: 'New Component', icon: <Plus {...ICON} />, onClick: () => setOpen(true) }}
//         defaultSort={{ key: 'code', dir: 'asc' }}
//         columns={[
//           { key: 'code', label: 'Code', className: 'font-semibold text-gray-900' },
//           { key: 'name', label: 'Component Name', grow: true, className: 'text-gray-700' },
//           { key: 'type', label: 'Type', align: 'center', render: (r) => <TypeCell type={r.type} /> },
//           { key: 'calcMethod', label: 'Calculation Method', className: 'text-gray-600' },
//           { key: 'taxable', label: 'Taxable', align: 'center', render: (r) => <BoolCell value={r.taxable} /> },
//           { key: 'epf', label: 'EPF', align: 'center', render: (r) => <BoolCell value={r.epf} /> },
//           { key: 'etf', label: 'ETF', align: 'center', render: (r) => <BoolCell value={r.etf} /> },
//           // { key: 'otPayable', label: 'OT Payable', align: 'center', render: (r) => <BoolCell value={r.otPayable} /> },
//           // { key: 'sortOrder', label: 'Sort Order', align: 'right', className: 'text-gray-600' },
//           statusColumn,
//         ]}
//         toolbarExtra={
//           <div className="flex flex-wrap items-end gap-2">
//             <div>
//               <span className={LABEL}>Component Type</span>
//               <select
//                 value={typeFilter}
//                 onChange={(e) => setTypeFilter(e.target.value)}
//                 className={`${FIELD} w-[150px]`}
//               >
//                 <option value="All">All</option>
//                 <option value="Earning">Earning</option>
//                 <option value="Deduction">Deduction</option>
//                 <option value="Contribution">Contribution</option>
//               </select>
//             </div>
//           </div>
//         }
//       />

//       <AddPayrollComponentDialog
//         open={open}
//         loading={saving}
//         onClose={() => setOpen(false)}
//         onSave={async (data) => {
//           await dispatch(savePayrollEntity('payrollComponents', data));

//           showToast('Payroll component added successfully.', 'success');

//           setOpen(false);
//         }}
//       />
//     </>
//   );
// };

// /* ── Salary Structures ───────────────────────────────────────────────────── */
// const SalaryStructuresTab = () => {
//   const { list, loading } = usePayrollEntity('salaryStructures');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Salary Structures"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['code', 'name', 'grade']}
//       searchPlaceholder="Search salary structures..."
//       onAdd={{ label: 'New Structure', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'code', label: 'Code', className: 'font-semibold text-gray-900' },
//         { key: 'name', label: 'Structure Name', grow: true, className: 'text-gray-700' },
//         { key: 'grade', label: 'Applicable Grade', className: 'text-gray-600' },
//         { key: 'components', label: 'Components', className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── Salary Components ───────────────────────────────────────────────────── */
// const SalaryComponentsTab = () => {
//   const { list, loading } = usePayrollEntity('salaryComponents');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Salary Components"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['code', 'name']}
//       searchPlaceholder="Search salary components..."
//       columns={[
//         { key: 'code', label: 'Code', className: 'font-semibold text-gray-900' },
//         { key: 'name', label: 'Component Name', grow: true, className: 'text-gray-700' },
//         { key: 'type', label: 'Type', align: 'center', render: (r) => <TypeCell type={r.type} /> },
//         { key: 'payType', label: 'Pay Type', className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── Payroll Configuration ───────────────────────────────────────────────── */
// const SETTINGS = [
//   { key: 'epfEtf', label: 'Auto-calculate EPF / ETF on payroll generation', on: true },
//   { key: 'paye', label: 'Auto-calculate PAYE using the active tax table', on: true },
//   { key: 'round', label: 'Round net pay to the nearest whole rupee', on: false },
//   { key: 'approval', label: 'Require approval before releasing payslips', on: true },
//   { key: 'negative', label: 'Allow negative net pay (advance recovery overrides)', on: false },
// ];

// const Toggle = ({ on, onClick }) => (
//   <button
//     type="button"
//     onClick={onClick}
//     role="switch"
//     aria-checked={on}
//     className={`relative w-10 h-5 shrink-0 rounded-full transition-colors ${
//       on ? 'bg-primary-600' : 'bg-gray-200'
//     }`}
//   >
//     <span
//       className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-transform ${
//         on ? 'translate-x-5' : ''
//       }`}
//     />
//   </button>
// );

// const ConfigurationTab = () => {
//   const [settings, setSettings] = useState(
//     () => Object.fromEntries(SETTINGS.map((s) => [s.key, s.on]))
//   );
//   const toggle = (key) => setSettings((prev) => ({ ...prev, [key]: !prev[key] }));

//   return (
//     <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
//       <div className="px-5 py-3.5 border-b border-gray-200">
//         <h3 className="text-sm font-semibold text-gray-900">Payroll Configuration</h3>
//       </div>
//       <div className="divide-y divide-gray-100">
//         {SETTINGS.map((s) => (
//           <div key={s.key} className="flex items-center justify-between gap-4 px-5 py-3.5">
//             <span className="text-[13px] text-gray-700">{s.label}</span>
//             <Toggle on={settings[s.key]} onClick={() => toggle(s.key)} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// /* ── GL Mapping ──────────────────────────────────────────────────────────── */
// const GLMappingTab = () => {
//   const { list, loading } = usePayrollEntity('glMapping');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="GL Mapping"
//       loading={loading}
//       // rows={list}
//       rows={[]}
//       rowKey="id"
//       searchKeys={['componentCode', 'componentName']}
//       searchPlaceholder="Search GL mappings..."
//       emptyMessage="No GL mappings found"
//       onAdd={{ label: 'New Mapping', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'componentCode', label: 'Component', className: 'font-semibold text-gray-900' },
//         { key: 'componentName', label: 'Component Name', grow: true, className: 'text-gray-700' },
//         { key: 'debitAccount', label: 'Debit Account', className: 'text-gray-600 tabular-nums' },
//         { key: 'creditAccount', label: 'Credit Account', className: 'text-gray-600 tabular-nums' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── Tax Configuration (PAYE) ────────────────────────────────────────────── */
// const TaxConfigurationTab = () => {
//   const { list, loading } = usePayrollEntity('taxConfiguration');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Tax Configuration (PAYE)"
//       loading={loading}
//       // rows={list}
//       rows={[]}
//       rowKey="id"
//       searchKeys={['bracket']}
//       searchPlaceholder="Search tax brackets..."
//       emptyMessage="No tax brackets found"
//       onAdd={{ label: 'New Bracket', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'bracket', label: 'Bracket', grow: true, className: 'font-semibold text-gray-900' },
//         { key: 'fromAmount', label: 'From (Rs.)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.fromAmount) },
//         {
//           key: 'toAmount', label: 'To (Rs.)', align: 'right', className: 'text-gray-600',
//           render: (r) => (r.toAmount == null ? <span className="text-gray-400">and above</span> : fmtMoney(r.toAmount)),
//         },
//         { key: 'rate', label: 'Rate', align: 'right', className: 'font-semibold text-gray-900' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── EPF / ETF Configuration ─────────────────────────────────────────────── */
// const EpfEtfTab = () => {
//   const { list, loading } = usePayrollEntity('epfEtfConfiguration');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="EPF / ETF Configuration"
//       loading={loading}
//       // rows={list}
//       rows={[]}
//       rowKey="id"
//       searchKeys={['type', 'contributor']}
//       searchPlaceholder="Search EPF/ETF configuration..."
//       emptyMessage="No EPF/ETF rules found"
//       onAdd={{ label: 'New Rule', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'type', label: 'Fund', className: 'font-semibold text-gray-900' },
//         { key: 'contributor', label: 'Contributor', className: 'text-gray-700' },
//         { key: 'rate', label: 'Rate', align: 'right', className: 'font-semibold text-gray-900' },
//         { key: 'basedOn', label: 'Based On', grow: true, className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── Bank Configuration ──────────────────────────────────────────────────── */
// const BankConfigurationTab = () => {
//   const { list, loading } = usePayrollEntity('bankConfiguration');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Bank Configuration"
//       loading={loading}
//       // rows={list}
//       rows={[]}
//       rowKey="id"
//       searchKeys={['bank', 'branchCode']}
//       searchPlaceholder="Search bank configuration..."
//       emptyMessage="No banks configured"
//       onAdd={{ label: 'New Bank', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'bank', label: 'Bank', grow: true, className: 'font-semibold text-gray-900' },
//         { key: 'branchCode', label: 'Branch Code', className: 'text-gray-600 tabular-nums' },
//         { key: 'swiftCode', label: 'Swift Code', className: 'text-gray-600' },
//         { key: 'fileFormat', label: 'File Format', className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── Page ────────────────────────────────────────────────────────────────── */
// const PayrollMasterFileMaintenance = () => {
//   const tabs = [
//     { key: 'periods', label: 'Payroll Periods', icon: <CalendarDays {...ICON} />, content: <PeriodsTab /> },
//     { key: 'components', label: 'Payroll Components', icon: <ListOrdered {...ICON} />, content: <ComponentsTab /> },
//     { key: 'structures', label: 'Salary Structures', icon: <Network {...ICON} />, content: <SalaryStructuresTab /> },
//     { key: 'salaryComponents', label: 'Salary Components', icon: <ListChecks {...ICON} />, content: <SalaryComponentsTab /> },
//     { key: 'config', label: 'Payroll Configuration', icon: <SlidersHorizontal {...ICON} />, content: <ConfigurationTab /> },
//     // { key: 'gl', label: 'GL Mapping', icon: <Puzzle {...ICON} />, content: <GLMappingTab /> },
//     // { key: 'tax', label: 'Tax Configuration (PAYE)', icon: <Receipt {...ICON} />, content: <TaxConfigurationTab /> },
//     // { key: 'epfEtf', label: 'EPF/ETF Configuration', icon: <PiggyBank {...ICON} />, content: <EpfEtfTab /> },
//     // { key: 'bank', label: 'Bank Configuration', icon: <Landmark {...ICON} />, content: <BankConfigurationTab /> },
//   ];

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={['Payroll', 'Master File Maintenance']}
//         title="Master File Maintenance"
//         subtitle="Maintain all payroll master data such as components, periods, salary structures, configuration and other payroll setup."
//       />

//       <Tabs tabs={tabs} defaultTab="periods" />
//     </div>
//   );
// };

// export default PayrollMasterFileMaintenance;

import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CalendarDays, ListOrdered, Network, ListChecks, SlidersHorizontal,
  Puzzle, Receipt, PiggyBank, Landmark, Plus,
  Eye,
  Pencil,
  SlidersVertical,
  Trash2,
  RotateCw,
} from 'lucide-react';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Tabs from '../../../components/Tabs/Tabs';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
import IsoDateInput from '../../../components/common/Isodateinput';
import SearchableSelect from '../../../components/common/SearchableSelect';

import usePayrollEntity from '../../../utils/usePayrollEntity';
import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
import { toIsoDate } from '../../../utils/dateFormat';
import { savePayrollEntity } from '../../../store/slices/payrollSlice';
import AddPayRollPeriodDialog from '../../../components/PayRoll/AddPayrollPeriodDialog';
import AddPayrollComponentDialog from '../../../components/PayRoll/AddPayrollComponentDialog';
import useToast from '../../../utils/useToast';
import Toast from '../../../components/Toast/Toast';
import tenant from '../../../config/tenant';
import { addMonthlyAllocation, getAllMonthlyAllocations, updateMonthlyAllocation, updateMonthlyAllocationStatus } from '../../../store/slices/monthlyAllocationSlice';
import { getEmployeeCategoryList } from '../../../store/slices/employeeCategorySlice';
import AddMonthlyAllocationDialog from '../../../components/PayRoll/AddMonthlyAllocationDialog';
import { useConfirm } from '../../../utils/ConfirmContext';
import { deleteSalaryStructure, getSalaryStructures, updateSalaryStructure } from '../../../store/slices/salaryStructureSlice';
import AddSalaryStructureDialog from '../../../components/SalaryStructure/AddSalaryStructureDialog';

/* Shared bits for this page. Field styling comes from the table theme so the
   toolbar controls match the table they sit on. */
const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
const LABEL = TABLE_THEME.fieldLabel;
const ICON = { size: 15 };

/* Every table on this page shares these — one place to change the page. */
const TABLE_PROPS = {
  search: true,
  searchLabel: 'Search',
  pageSize: 10,
  scrollClassName: '',            // paged, so no scroll box
  emptyMessage: 'No records found',
  loadingMessage: 'Loading...',
};

const statusColumn = {
  key: 'status',
  label: 'Status',
  align: 'center',
  render: (r) => <StatusPill label={r.status} />,
};

const MONTH_NAMES = [
  "", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
]

/* Earning / Deduction / Contribution, in the pill language of the table. */
const TYPE_TONES = { Earning: 'success', Deduction: 'danger', Contribution: 'info' };
const TypeCell = ({ type }) => <StatusPill label={type} tone={TYPE_TONES[type]} dot={false} />;

const BoolCell = ({ value }) => (
  <span className={value ? 'text-primary-700 font-semibold' : 'text-gray-400'}>
    {value ? 'Yes' : 'No'}
  </span>
);

/* ── Payroll Periods ─────────────────────────────────────────────────────── */
const PeriodsTab = () => {
  const dispatch = useDispatch();
  const { list, loading } = usePayrollEntity('payrollPeriods');
  const saving = useSelector((s) => s.payroll.entities.payrollPeriods?.saving);

  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('add');
  const [selectedPeriod, setSelectedPeriod] = useState(null);

  const [periodType, setPeriodType] = useState('All');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const { toast, showToast, hideToast } = useToast();

  const filteredPeriods = list
    .filter((period) => {
      // Frequency filter
      if (periodType !== 'All' && period.frequency !== periodType) {
        return false;
      }

      const periodStart = toIsoDate(period.startDate);
      const periodEnd = toIsoDate(period.endDate);

      // From date
      if (fromDate && periodStart < fromDate) {
        return false;
      }

      // End date filter
      if (toDate && periodEnd && periodEnd > toDate) {
        return false;
      }

      return true;
    })

  
  const handleAddPeriod = () => {
    setSelectedPeriod(null);
    setDialogMode('add');
    setOpen(true);
  }

  const handleViewPeriod = (period) => {
    setSelectedPeriod(period);
    setDialogMode('view');
    setOpen(true);
  }

  const handleEditPeriod = (period) => {
    setSelectedPeriod(period);
    setDialogMode('edit');
    setOpen(true);
  }

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedPeriod(null);
    setDialogMode('add');
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Payroll Periods"
        loading={loading}
        rows={filteredPeriods}
        rowKey="id"
        searchKeys={['code', 'name']}
        searchPlaceholder="Search periods..."
        onAdd={{ label: 'New Period', icon: <Plus {...ICON} />, onClick: handleAddPeriod}}
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-2">
            <div>
              <span className={LABEL}>Period Type</span>
              <select
                value={periodType}
                onChange={(e) => setPeriodType(e.target.value)}
                className={`${FIELD} w-[130px]`}
              >
                <option value="All">All</option>
                <option value="Monthly">Monthly</option>
                <option value="Weekly">Weekly</option>
              </select>
            </div>
            <div>
              <span className={LABEL}>From</span>
              <IsoDateInput value={fromDate} onChange={setFromDate} className={`${FIELD} w-[150px]`} />
            </div>
            <div>
              <span className={LABEL}>To</span>
              <IsoDateInput value={toDate} onChange={setToDate} className={`${FIELD} w-[150px]`} />
            </div>
          </div>
        }
        defaultSort={{ key: 'code', dir: 'asc' }}
        columns={[
          { key: 'code', label: 'Period Code', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Period Name', grow: true, className: 'text-gray-700' },
          {
            key: 'frequency',
            label: 'Frequency',
            align: 'center',
            className: 'text-gray-600',
          },
          { key: 'startDate', label: 'Start Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.startDate) },
          { key: 'endDate', label: 'End Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.endDate) },
          { key: 'payDate', label: 'Pay Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.payDate) },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className="flex items-center justify-center gap-1">
                <button
                  type="button"
                  onClick={() => handleViewPeriod(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                  title="View"
                  aria-label={`View ${r.name || r.code}`}
                >
                  <Eye size={15} />
                </button>

                <button
                  type="button"
                  onClick={() => handleEditPeriod(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-primary-600 hover:bg-gray-100 hover:text-gray-700"
                  title="Edit"
                  aria-label={`Edit ${r.name || r.code}`}
                >
                  <Pencil size={15} />
                </button>
              </div>
            ),
          },
        ]}
      />

      <AddPayRollPeriodDialog
        open={open}
        loading={saving}
        mode={dialogMode}
        period={selectedPeriod}
        existingPeriods={list}
        onClose={handleCloseDialog}
        onSave={async (data) => {
          try {
            await dispatch(savePayrollEntity('payrollPeriods', data, dialogMode === 'edit'));

            showToast(
              dialogMode === 'edit'
                ? 'Payroll period updated successfully.'
                : 'Payroll period added successfully.',
              'success'
            );

            handleCloseDialog();
          } catch (error) {
            showToast(error?.msg || error?.message || 'Failed to save payroll period.', 'error');
          }
        }}
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
};

/* ── Payroll Components ──────────────────────────────────────────────────── */
const ComponentsTab = () => {
  const dispatch = useDispatch();
  const { list, loading } = usePayrollEntity('payrollComponents');
  const saving = useSelector((s) => s.payroll.entities.payrollComponents?.saving);

  const [open, setOpen] = useState(false);
  const [typeFilter, setTypeFilter] = useState('All');
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [dialogMode, setDialogMode] = useState('All');

  const { toast, showToast, hideToast } = useToast();

  const filteredComponents = [...list]
  .filter((component) => typeFilter === 'All' || component.type === typeFilter)
  .sort((a, b) => String(a.code || '').localeCompare(String(b.code || '')));

  const handleOpenAdd = () => {
    setSelectedComponent(null);
    setDialogMode('add');
    setOpen(true);
  };

  const handleOpenView = (component) => {
    setSelectedComponent(component);
    setDialogMode('view');
    setOpen(true);
  };

  const handleOpenEdit = (component) => {
    setSelectedComponent(component);
    setDialogMode('edit');
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedComponent(null);
    setDialogMode('add');
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Payroll Components"
        loading={loading}
        rows={filteredComponents}
        rowKey="id"
        searchKeys={['code', 'name']}
        searchPlaceholder="Search components..."
        onAdd={{ label: 'New Component', icon: <Plus {...ICON} />, onClick: () => setOpen(true) }}
        defaultSort={{ key: 'code', dir: 'asc' }}
        columns={[
          { key: 'code', label: 'Code', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Component Name', grow: true, className: 'text-gray-700' },
          { key: 'type', label: 'Type', align: 'center', render: (r) => <TypeCell type={r.type} /> },
          { key: 'calcMethod', label: 'Calculation Method', className: 'text-gray-600' },
          { key: 'taxable', label: 'Payee', align: 'center', render: (r) => <BoolCell value={r.taxable} /> },
          { key: 'epf', label: 'EPF', align: 'center', render: (r) => <BoolCell value={r.epf} /> },
          { key: 'etf', label: 'ETF', align: 'center', render: (r) => <BoolCell value={r.etf} /> },
          { key: 'ot', label: 'OT', align: 'center', render: (r) => <BoolCell value={r.otPayable} /> },
          { key: 'noPay', label: 'No Pay', align: 'center', render: (r) => <BoolCell value={r.isNoPay} /> },
          // { key: 'otPayable', label: 'OT Payable', align: 'center', render: (r) => <BoolCell value={r.otPayable} /> },
          // { key: 'sortOrder', label: 'Sort Order', align: 'right', className: 'text-gray-600' },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className="flex items-center justify-center gap-1">
                <button
                  type="button"
                  onClick={() => handleOpenView(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                  title="View"
                  aria-label={`View ${r.name || r.code}`}
                >
                  <Eye size={15} />
                </button>

                <button
                  type="button"
                  onClick={() => handleOpenEdit(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-primary-600 hover:bg-gray-100 hover:text-primary-700"
                  title="Edit"
                  aria-label={`Edit ${r.name || r.code}`}
                >
                  <Pencil size={15} />
                </button>
              </div>
            ),
          },
        ]}
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-2">
            <div>
              <span className={LABEL}>Component Type</span>
              <select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                className={`${FIELD} w-[150px]`}
              >
                <option value="All">All</option>
                <option value="Earning">Earning</option>
                <option value="Deduction">Deduction</option>
                <option value="Contribution">Contribution</option>
              </select>
            </div>
          </div>
        }
      />

      <AddPayrollComponentDialog
        open={open}
        loading={saving}
        mode={dialogMode}
        component={selectedComponent}
        onClose={handleCloseDialog}
        onSave={async (data) => {
          try {
            await dispatch(savePayrollEntity('payrollComponents', data, dialogMode === 'edit'));

            showToast(
              dialogMode === 'edit'
                ? 'Payroll component updated successfully.'
                : 'Payroll component added successfully.',
              'success'
            );

            handleCloseDialog();
          } catch (error) {
            showToast(error?.msg || error?.message || 'Failed to save payroll component.', 'error');
          }
        }}
      />
    </>
  );
};

/* ── Monthly Allocation ───────────────────────────────────────────────────── */
const MonthlyAllocationTab = () => {
  const dispatch = useDispatch();
  const { toast, showToast, hideToast } = useToast();
  const confirm = useConfirm();

  const { allocations = [], loading, saving } = useSelector((s) => s.monthlyAllocation || {});
  const { categories = [] } = useSelector((s) => s.employeeCategorySlice || {});

  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('add');
  const [selectedAllocation, setSelectedAllocation] = useState(null);

  // Filters
  const [selectedYear, setSelectedYear] = useState('All');
  const [selectedMonth, setSelectedMonth] = useState('All');

  useEffect(() => {
    dispatch(getAllMonthlyAllocations());
    dispatch(getEmployeeCategoryList());
  }, [dispatch]);

  // Lookup for category code -> category name
  const categoryMap = useMemo(() => {
    const map = {};
    categories.forEach((cat) => {
      map[cat.code] = cat.name;
    });
    return map;
  }, [categories]);

  // Transform raw API response
  const rows = useMemo(() => {
    return (allocations || []).map((item) => ({
      id: item.HMA_ALLOCATION_ID,
      year: item.HMA_YEAR,
      month: Number(item.HMA_MONTH),
      monthName: MONTH_NAMES[Number(item.HMA_MONTH)] || item.HMA_MONTH,
      categoryCode: item.HMA_CATEGORY_CODE,
      categoryName: categoryMap[item.HMA_CATEGORY_CODE] || item.HMA_CATEGORY_CODE,
      allocationDays: parseFloat(item.HMA_ALLOCATION_DAYS || 0),
      allocationHours: parseFloat(item.HMA_ALLOCATION_HOURS || 0),
      status: String(item.HMA_IS_ACTIVE).toLowerCase() === 'true' ? 'Active' : 'Inactive',
      raw: item,
    }));
  }, [allocations, categoryMap]);

  const filteredRows = useMemo(() => {
    return rows.filter((r) => {
      if (r.status === 'Inactive') return false;
      if (selectedYear !== 'All' && String(r.year) !== String(selectedYear)) return false;
      if (selectedMonth !== 'All' && String(r.month) !== String(selectedMonth)) return false;
      return true;
    });
  }, [rows, selectedYear, selectedMonth]);

  const availableYears = useMemo(() => {
    const unique = [...new Set(rows.map((r) => r.year))].filter(Boolean);
    if (!unique.includes(String(new Date().getFullYear()))) {
      unique.push(String(new Date().getFullYear()));
    }
    return unique.sort((a, b) => b - a);
  }, [rows]);

  const handleOpenAdd = () => {
    setSelectedAllocation(null);
    setDialogMode('add');
    setOpen(true);
  };

  const handleOpenView = (record) => {
    setSelectedAllocation(record.raw);
    setDialogMode('view');
    setOpen(true);
  };

  const handleOpenEdit = (record) => {
    setSelectedAllocation(record.raw);
    setDialogMode('edit');
    setOpen(true);
  };

  const handleToggleStatus = async (record) => {
    const isCurrentlyActive = record.status === 'Active';
    const confirmMsg = isCurrentlyActive
      ? `Are you sure you want to deactivate the allocation for ${record.categoryName} (${record.monthName} ${record.year})?`
      : `Are you sure you want to activate the allocation for ${record.categoryName} (${record.monthName} ${record.year})?`;

    const confirmed = await confirm({
      title: "Delete this allocation?",
      message: `${confirmMsg}`,
      confirmLabel: "Delete",
      cancelLabel: "Cancel",
    });

    if (!confirmed) {
      return;
    }

    try {
      await dispatch(
        updateMonthlyAllocationStatus({
          allocationId: record.id,
          isActive: !isCurrentlyActive ? 1 : 0,
        })
      );

      showToast(
        isCurrentlyActive ? 'Monthly allocation deactivated.' : 'Monthly allocation activated.',
        'success'
      );
      dispatch(getAllMonthlyAllocations());
    } catch (err) {
      showToast(err || 'Failed to update monthly allocation status.', 'error');
    }
  };

  const handleSave = async (formData) => {
    try {
      if (dialogMode === 'edit') {
        await dispatch(
          updateMonthlyAllocation({
            allocationId: selectedAllocation?.HMA_ALLOCATION_ID,
            year: formData.year,
            month: formData.month,
            categoryCode: formData.categoryCode,
            allocationDays: formData.allocationDays,
            allocationHours: formData.allocationHours,
          })
        );

        showToast('Monthly allocation updated successfully.', 'success');
      } else {
        await dispatch(addMonthlyAllocation(formData));
        showToast('Monthly allocation created successfully.', 'success');
      }

      setOpen(false);
      dispatch(getAllMonthlyAllocations());
    } catch (error) {
      showToast(error || 'Failed to save monthly allocation.', 'error');
    }
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Monthly Allocation"
        loading={loading}
        rows={filteredRows}
        rowKey="id"
        searchKeys={['year', 'monthName', 'categoryName', 'categoryCode']}
        searchPlaceholder="Search allocations..."
        onAdd={{ label: 'New Allocation', icon: <Plus {...ICON} />, onClick: handleOpenAdd }}
        defaultSort={{ key: 'year', dir: 'desc' }}
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-2">
            <div>
              <span className={LABEL}>Year</span>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                className={`${FIELD} w-[110px]`}
              >
                <option value="All">All</option>
                {availableYears.map((yr) => (
                  <option key={yr} value={yr}>{yr}</option>
                ))}
              </select>
            </div>
            <div>
              <span className={LABEL}>Month</span>
              <div className="w-[130px]">
                <SearchableSelect
                  value={selectedMonth}
                  onChange={setSelectedMonth}
                  options={MONTH_NAMES.slice(1).map((mName, idx) => ({ value: idx + 1, label: mName }))}
                  emptyOption={{ value: 'All', label: 'All' }}
                  searchPlaceholder="Search month..."
                  className={`${FIELD} w-full`}
                />
              </div>
            </div>
          </div>
        }
        columns={[
          { key: 'year', label: 'Year', align: 'center', className: 'font-semibold text-gray-900' },
          { key: 'monthName', label: 'Month', align: 'center', className: 'text-gray-700' },
          {
            key: 'categoryName',
            label: 'Employee Category',
            grow: true,
            className: 'font-medium text-gray-800',
            render: (r) => (
              <div>
                <span>{r.categoryName}</span>
                <span className="ml-1.5 text-xs text-gray-400">({r.categoryCode})</span>
              </div>
            ),
          },
          {
            key: 'allocationDays',
            label: 'Days',
            align: 'right',
            className: 'text-gray-800 tabular-nums font-medium',
          },
          {
            key: 'allocationHours',
            label: 'Hours',
            align: 'right',
            className: 'text-gray-800 tabular-nums font-medium',
          },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className="flex items-center justify-center gap-1">
                <button
                  type="button"
                  onClick={() => handleOpenView(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                  title="View"
                >
                  <Eye size={15} />
                </button>

                <button
                  type="button"
                  onClick={() => handleOpenEdit(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-primary-600 hover:bg-gray-100 hover:text-primary-700"
                  title="Edit"
                >
                  <Pencil size={15} />
                </button>

                <button
                  type="button"
                  onClick={() => handleToggleStatus(r)}
                  className={`inline-flex h-8 w-8 items-center justify-center rounded-md ${
                    r.status === 'Active'
                      ? 'text-red-500 hover:bg-red-50 hover:text-red-700'
                      : 'text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700'
                  }`}
                  title={r.status === 'Active' ? 'Deactivate' : 'Activate'}
                >
                  <Trash2 size={15} />
                </button>
              </div>
            ),
          },
        ]}
      />

      <AddMonthlyAllocationDialog 
        open={open}
        loading={saving}
        mode={dialogMode}
        allocation={selectedAllocation}
        categories={categories}
        onClose={() => setOpen(false)}
        onSave={handleSave}
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
}

/* ── Salary Structures ───────────────────────────────────────────────────── */
const SalaryStructuresTab = () => {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { toast, showToast, hideToast } = useToast();
  
  const {
    structures = [],
    loading,
    saving
  } = useSelector((s) => s.salaryStructure || {});

  const [open, setOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState('add');
  const [selectedStructure, setSelectedStructure] = useState(null);
  const [statusFilter, setStatusFilter] = useState('All');

  const employeeCategories = useSelector(
    (s) => s.employeeCategorySlice?.categories || []
  )

  useEffect(() => {
    dispatch(getSalaryStructures());
    dispatch(getEmployeeCategoryList());
  }, [dispatch]);

  const filteredStructures = useMemo(() => {
    return structures
      .filter((item) => {
        if (statusFilter !== 'All' && item.status !== statusFilter) return false;
        return true;
      })
      .map((item) => {
        const matched = employeeCategories.find(
          (c) => String(c.code).trim().toLowerCase() === String(item.categoryCode).trim().toLowerCase()
        );
        return {
          ...item,
          categoryName: matched?.name || item.categoryCode || '',
        };
      });
  }, [structures, statusFilter, employeeCategories]);

  const handleOpenAdd = () => {
    setSelectedStructure(null);
    setDialogMode('add');
    setOpen(true);
  };

  const handleOpenView = (structure) => {
    setSelectedStructure(structure);
    setDialogMode('view');
    setOpen(true);
  };

  const handleOpenEdit = (structure) => {
    setSelectedStructure(structure);
    setDialogMode('edit');
    setOpen(true);
  };

  const handleToggleStatus = async (structure) => {
    const isCurrentlyActive = structure.status === 'Active';
    const confirmed = await confirm({
      title: isCurrentlyActive ? 'Deactivate Salary Structure?' : 'Reactivate Salary Structure?',
      message: `Are you sure you want to ${isCurrentlyActive ? 'deactivate' : 'activate'} "${structure.name}"?`,
      confirmLabel: isCurrentlyActive ? 'Deactivate' : 'Activate',
      cancelLabel: 'Cancel',
    });

    if (!confirmed) return;

    try {
      if (isCurrentlyActive) {
        await dispatch(deleteSalaryStructure(structure.id)).unwrap();
      } else {
        await dispatch(
          updateSalaryStructure({
            structureId: structure.id,
            isActive: true,
          })
        ).unwrap();
      }

      showToast(
        `Salary structure ${isCurrentlyActive ? 'deactivated' : 'activated'} successfully.`,
        'success'
      );
      dispatch(getSalaryStructures());
    } catch (err) {
      showToast(err || 'Failed to update salary structure status.', 'error');
    }
  };

  return (
    <>
      <Table 
        {...TABLE_PROPS}
        title="Salary Structures"
        loading={loading}
        rows={filteredStructures}
        rowKey='id'
        searchKeys={['code', 'name', 'categoryCode', 'categoryName', 'remarks']}
        searchPlaceholder='Search salary structures...'
        onAdd={{
          label: 'New Structure',
          icon: <Plus {...ICON} />,
          onClick: handleOpenAdd
        }}
        defaultSort={{
          key: 'code',
          dir: 'asc'
        }}

        toolbarExtra={
          <div className="flex flex-wrap items-end gap-2">
            <div>
              <span className={LABEL}>Status</span>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className={`${FIELD} w-[130px]`}
              >
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>
        }
        columns={[
          { key: 'code', label: 'Code', className: 'font-semibold text-gray-900' },
          { key: 'name', label: 'Structure Name', grow: true, className: 'text-gray-700' },
          {
            key: 'categoryCode',
            label: 'Category',
            align: 'center',
            render: (r) => {
              const matched = employeeCategories.find((c) => c.code.trim().toLowerCase() === r.categoryCode.trim().toLowerCase());

              const displayName = matched?.name || r.categoryCode || "-"

              return (
                <span
                  className="inline-flex items-center rounded-md bg-surface-100 px-2 py-0.5 text-xs font-medium text-gray-600"
                  title={r.categoryCode ? `Code: ${r.categoryCode}` : ''}
                >
                  {displayName}
                </span>
              )
            }
          },
          { key: 'versionNo', label: 'Version', align: 'center', className: 'text-gray-600 tabular-nums' },
          { key: 'effectiveDate', label: 'Effective Date', align: 'center', className: 'text-gray-600 tabular-nums' },
          { key: 'remarks', label: 'Remarks', grow: true, className: 'text-gray-500' },
          statusColumn,
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            render: (r) => (
              <div className="flex items-center justify-center gap-1">
                <button
                  type="button"
                  onClick={() => handleOpenView(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                  title="View"
                >
                  <Eye size={15} />
                </button>

                <button
                  type="button"
                  onClick={() => handleOpenEdit(r)}
                  className="inline-flex h-8 w-8 items-center justify-center rounded-md text-primary-600 hover:bg-gray-100 hover:text-primary-700"
                  title="Edit"
                >
                  <Pencil size={15} />
                </button>

                <button
                  type="button"
                  onClick={() => handleToggleStatus(r)}
                  className={`inline-flex h-8 w-8 items-center justify-center rounded-md ${
                    r.status === 'Active'
                      ? 'text-red-500 hover:bg-red-50 hover:text-red-700'
                      : 'text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700'
                  }`}
                  title={r.status === 'Active' ? 'Deactivate' : 'Reactivate'}
                >
                  {r.status === 'Active' ? <Trash2 size={15} /> : <RotateCw size={15} />}
                </button>
              </div>
            ),
          },
        ]}
      />

      {open && (
        <AddSalaryStructureDialog
          open={open}
          loading={saving}
          mode={dialogMode}
          structure={selectedStructure}
          onClose={() => {
            setOpen(false);
            setSelectedStructure(null);
          }}
          onSuccess={() => {
            setOpen(false);
            setSelectedStructure(null);
            dispatch(getSalaryStructures());
          }}
        />
      )}

      <Toast 
        message={toast?.message} 
        type={toast?.type} 
        onClose={hideToast} 
      />
    </>
  )
};

/* ── Salary Components ───────────────────────────────────────────────────── */
const SalaryComponentsTab = () => {
  const { list, loading } = usePayrollEntity('salaryComponents');
  return (
    <Table
      {...TABLE_PROPS}
      title="Salary Components"
      loading={loading}
      rows={list}
      rowKey="id"
      searchKeys={['code', 'name']}
      searchPlaceholder="Search salary components..."
      columns={[
        { key: 'code', label: 'Code', className: 'font-semibold text-gray-900' },
        { key: 'name', label: 'Component Name', grow: true, className: 'text-gray-700' },
        { key: 'type', label: 'Type', align: 'center', render: (r) => <TypeCell type={r.type} /> },
        { key: 'payType', label: 'Pay Type', className: 'text-gray-600' },
        statusColumn,
      ]}
    />
  );
};

/* ── Payroll Configuration ───────────────────────────────────────────────── */
const SETTINGS = [
  { key: 'epfEtf', label: 'Auto-calculate EPF / ETF on payroll generation', on: true },
  { key: 'paye', label: 'Auto-calculate PAYE using the active tax table', on: true },
  { key: 'round', label: 'Round net pay to the nearest whole rupee', on: false },
  { key: 'approval', label: 'Require approval before releasing payslips', on: true },
  { key: 'negative', label: 'Allow negative net pay (advance recovery overrides)', on: false },
];

const Toggle = ({ on, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    role="switch"
    aria-checked={on}
    className={`relative w-10 h-5 shrink-0 rounded-full transition-colors ${
      on ? 'bg-primary-600' : 'bg-gray-200'
    }`}
  >
    <span
      className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-transform ${
        on ? 'translate-x-5' : ''
      }`}
    />
  </button>
);

const ConfigurationTab = () => {
  const [settings, setSettings] = useState(
    () => Object.fromEntries(SETTINGS.map((s) => [s.key, s.on]))
  );
  const toggle = (key) => setSettings((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <div className="px-5 py-3.5 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900">Payroll Configuration</h3>
      </div>
      <div className="divide-y divide-gray-100">
        {SETTINGS.map((s) => (
          <div key={s.key} className="flex items-center justify-between gap-4 px-5 py-3.5">
            <span className="text-[13px] text-gray-700">{s.label}</span>
            <Toggle on={settings[s.key]} onClick={() => toggle(s.key)} />
          </div>
        ))}
      </div>
    </div>
  );
};

/* ── GL Mapping ──────────────────────────────────────────────────────────── */
const GLMappingTab = () => {
  const { list, loading } = usePayrollEntity('glMapping');
  return (
    <Table
      {...TABLE_PROPS}
      title="GL Mapping"
      loading={loading}
      // rows={list}
      rows={[]}
      rowKey="id"
      searchKeys={['componentCode', 'componentName']}
      searchPlaceholder="Search GL mappings..."
      emptyMessage="No GL mappings found"
      onAdd={{ label: 'New Mapping', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'componentCode', label: 'Component', className: 'font-semibold text-gray-900' },
        { key: 'componentName', label: 'Component Name', grow: true, className: 'text-gray-700' },
        { key: 'debitAccount', label: 'Debit Account', className: 'text-gray-600 tabular-nums' },
        { key: 'creditAccount', label: 'Credit Account', className: 'text-gray-600 tabular-nums' },
        statusColumn,
      ]}
    />
  );
};

/* ── Tax Configuration (PAYE) ────────────────────────────────────────────── */
const TaxConfigurationTab = () => {
  const { list, loading } = usePayrollEntity('taxConfiguration');
  return (
    <Table
      {...TABLE_PROPS}
      title="Tax Configuration (PAYE)"
      loading={loading}
      // rows={list}
      rows={[]}
      rowKey="id"
      searchKeys={['bracket']}
      searchPlaceholder="Search tax brackets..."
      emptyMessage="No tax brackets found"
      onAdd={{ label: 'New Bracket', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'bracket', label: 'Bracket', grow: true, className: 'font-semibold text-gray-900' },
        { key: 'fromAmount', label: 'From (Rs.)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.fromAmount) },
        {
          key: 'toAmount', label: 'To (Rs.)', align: 'right', className: 'text-gray-600',
          render: (r) => (r.toAmount == null ? <span className="text-gray-400">and above</span> : fmtMoney(r.toAmount)),
        },
        { key: 'rate', label: 'Rate', align: 'right', className: 'font-semibold text-gray-900' },
        statusColumn,
      ]}
    />
  );
};

/* ── EPF / ETF Configuration ─────────────────────────────────────────────── */
const EpfEtfTab = () => {
  const { list, loading } = usePayrollEntity('epfEtfConfiguration');
  return (
    <Table
      {...TABLE_PROPS}
      title="EPF / ETF Configuration"
      loading={loading}
      // rows={list}
      rows={[]}
      rowKey="id"
      searchKeys={['type', 'contributor']}
      searchPlaceholder="Search EPF/ETF configuration..."
      emptyMessage="No EPF/ETF rules found"
      onAdd={{ label: 'New Rule', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'type', label: 'Fund', className: 'font-semibold text-gray-900' },
        { key: 'contributor', label: 'Contributor', className: 'text-gray-700' },
        { key: 'rate', label: 'Rate', align: 'right', className: 'font-semibold text-gray-900' },
        { key: 'basedOn', label: 'Based On', grow: true, className: 'text-gray-600' },
        statusColumn,
      ]}
    />
  );
};

/* ── Bank Configuration ──────────────────────────────────────────────────── */
const BankConfigurationTab = () => {
  const { list, loading } = usePayrollEntity('bankConfiguration');
  return (
    <Table
      {...TABLE_PROPS}
      title="Bank Configuration"
      loading={loading}
      // rows={list}
      rows={[]}
      rowKey="id"
      searchKeys={['bank', 'branchCode']}
      searchPlaceholder="Search bank configuration..."
      emptyMessage="No banks configured"
      onAdd={{ label: 'New Bank', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'bank', label: 'Bank', grow: true, className: 'font-semibold text-gray-900' },
        { key: 'branchCode', label: 'Branch Code', className: 'text-gray-600 tabular-nums' },
        { key: 'swiftCode', label: 'Swift Code', className: 'text-gray-600' },
        { key: 'fileFormat', label: 'File Format', className: 'text-gray-600' },
        statusColumn,
      ]}
    />
  );
};

/* ── Page ────────────────────────────────────────────────────────────────── */
const PayrollMasterFileMaintenance = () => {
  const tabs = [
    { key: 'periods', label: 'Payroll Periods', icon: <CalendarDays {...ICON} />, content: <PeriodsTab /> },
    { key: 'components', label: 'Payroll Components', icon: <ListOrdered {...ICON} />, content: <ComponentsTab /> },
    ...(tenant.featureFlags.enableMonthlyAllocation
      ? [{ 
        key: 'monthlyAllocation', 
        label: 'Monthly Allocation', 
        icon: <SlidersVertical {...ICON} />, 
        content: <MonthlyAllocationTab />
      }]
      : []
    ),
    { key: 'structures', label: 'Salary Structures', icon: <Network {...ICON} />, content: <SalaryStructuresTab /> },
    { key: 'salaryComponents', label: 'Salary Components', icon: <ListChecks {...ICON} />, content: <SalaryComponentsTab /> },
    { key: 'config', label: 'Payroll Configuration', icon: <SlidersHorizontal {...ICON} />, content: <ConfigurationTab /> },
    // { key: 'gl', label: 'GL Mapping', icon: <Puzzle {...ICON} />, content: <GLMappingTab /> },
    // { key: 'tax', label: 'Tax Configuration (PAYE)', icon: <Receipt {...ICON} />, content: <TaxConfigurationTab /> },
    // { key: 'epfEtf', label: 'EPF/ETF Configuration', icon: <PiggyBank {...ICON} />, content: <EpfEtfTab /> },
    // { key: 'bank', label: 'Bank Configuration', icon: <Landmark {...ICON} />, content: <BankConfigurationTab /> },
  ];

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Payroll', 'Master File Maintenance']}
        title="Master File Maintenance"
        subtitle="Maintain all payroll master data such as components, periods, salary structures, configuration and other payroll setup."
      />

      <Tabs tabs={tabs} defaultTab="periods" />
    </div>
  );
};

export default PayrollMasterFileMaintenance;